import { render } from "./OrgOverview.vue?vue&type=template&id=002aacc8&scoped=true"
import script from "./OrgOverview.vue?vue&type=script&lang=js"
export * from "./OrgOverview.vue?vue&type=script&lang=js"

import "./OrgOverview.vue?vue&type=style&index=0&id=002aacc8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002aacc8"]])

export default __exports__